import React from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ProductEnum, ProductMap, getProductType } from "../../constants/login";
import VersaQuestionnaire from "./products/VersaQuestionnaire";

const VERSA_PRODUCT_ID = ProductMap[ProductEnum.VERSA];

export type QuestionnaireProps = {
  /** From URL / session; drives which product questionnaire renders. */
  productId: number;
};

/**
 * Product-aware questionnaire shell. Add a branch (or registry entry) per product
 * with its own sections, accordions, and payload types.
 */
const Questionnaire = ({ productId }: QuestionnaireProps) => {
  const productName = getProductType(productId);

  if (!productId || Number.isNaN(productId)) {
    return (
      <Paper sx={{ p: 2, width: "100%" }}>
        <Typography color="text.secondary">
          Open onboarding with a valid product in the URL to load the matching
          questionnaire.
        </Typography>
      </Paper>
    );
  }

  if (productId === VERSA_PRODUCT_ID) {
    return <VersaQuestionnaire />;
  }

  return (
    <Paper sx={{ p: 2, width: "100%" }}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          Questionnaire
        </Typography>
        <Typography color="text.secondary">
          No questionnaire is configured for{" "}
          <strong>{productName ?? `product id ${productId}`}</strong> yet. Versa
          is supported; additional products can be wired here when their
          questions are ready.
        </Typography>
      </Stack>
    </Paper>
  );
};

export default Questionnaire;
